import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

const TeacherDashboard = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');

      const snapshot = await getDocs(collection(db, 'escapeRoomProgress'));
      const docs = [];
      snapshot.forEach((docSnap) => {
        docs.push({ id: docSnap.id, ...docSnap.data() });
      });

      setRecords(docs);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error loading progress data', err);
      setError('Failed to load data from Firestore.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // Aggregate by student (first name + last initial)
  const studentsMap = {};
  records.forEach((r) => {
    const first = r.studentFirstName || 'Unknown';
    const last = r.studentLastInitial || '';
    const key = `${first} ${last}`.trim();
    if (!studentsMap[key]) {
      studentsMap[key] = {
        name: key,
        sessions: new Set(),
        totalAttempts: 0,
        maxQuestionsCompleted: 0,
        lastActivity: null,
      };
    }
    const entry = studentsMap[key];
    if (r.sessionId) entry.sessions.add(r.sessionId);
    entry.totalAttempts += 1;

    if (typeof r.questionsCompleted === 'number') {
      entry.maxQuestionsCompleted = Math.max(entry.maxQuestionsCompleted, r.questionsCompleted);
    }
    if (typeof r.questionsCompletedBefore === 'number') {
      entry.maxQuestionsCompleted = Math.max(entry.maxQuestionsCompleted, r.questionsCompletedBefore);
    }

    if (r.createdAt) {
      const ts = new Date(r.createdAt).getTime();
      if (!entry.lastActivity || ts > entry.lastActivity) {
        entry.lastActivity = ts;
      }
    }
  });

  const students = Object.values(studentsMap).sort((a, b) => {
    const aTime = a.lastActivity || 0;
    const bTime = b.lastActivity || 0;
    return bTime - aTime;
  });

  return (
    <div
      style={{
        minHeight: '100vh',
        padding: '2rem',
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #6dd5ed 100%)',
        color: '#fff',
      }}
    >
      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
          background: '#ffffff',
          borderRadius: '16px',
          padding: '1.75rem 2rem',
          boxShadow: '0 12px 30px rgba(0,0,0,0.25)',
          color: '#222',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h1 style={{ margin: 0, fontSize: '1.8rem' }}>Escape Room Dashboard</h1>
          <button
            onClick={loadData}
            style={{
              borderRadius: '999px',
              border: 'none',
              background: '#1e88e5',
              color: '#fff',
              padding: '0.5rem 1.2rem',
              cursor: 'pointer',
              fontSize: '0.95rem',
              boxShadow: '0 4px 10px rgba(30,136,229,0.5)',
            }}
          >
            Refresh
          </button>
        </div>

        {loading && <p>Loading student progress...</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}

        {!loading && students.length === 0 && (
          <p>No progress data found yet. Have students play the escape room first.</p>
        )}

        {!loading && students.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>Student</th>
                  <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>Sessions</th>
                  <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>
                    Max Questions Completed
                  </th>
                  <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>
                    Total Attempts
                  </th>
                  <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>Last Activity</th>
                </tr>
              </thead>
              <tbody>
                {students.map((s) => (
                  <tr key={s.name}>
                    <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{s.name}</td>
                    <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{s.sessions.size}</td>
                    <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{s.maxQuestionsCompleted}</td>
                    <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{s.totalAttempts}</td>
                    <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>
                      {s.lastActivity ? new Date(s.lastActivity).toLocaleString() : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherDashboard;

